import { FC, useEffect } from "react";

import { TrainingDrillsTourSteps } from "@/features/training/pages/drill-tab/TrainingDrillsTourSteps";
import { DrillFoldersAccordion } from "@/features/training/pages/drill-tab/panel-left/accordion/DrillFoldersAccordion";
import { Box } from "@mui/material";
import { useTour } from "@reactour/tour";

export const DrillPanelLeft: FC = () => {
	const { setSteps, setCurrentStep } = useTour();

	useEffect(() => {
		setCurrentStep(0);
		if (setSteps) setSteps(TrainingDrillsTourSteps);
	}, [setSteps, setCurrentStep]);

	return (
		<Box
			sx={{
				flex: 1,
				minHeight: 0,
				display: "flex",
				flexDirection: "column",
				overflow: "hidden",
			}}
		>
			<Box
				data-tour="training-drills-folders"
				sx={{
					flex: 1,
					minHeight: 0,
					overflow: "hidden",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<DrillFoldersAccordion />
			</Box>
		</Box>
	);
};
